var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","disabled":_vm.loading},on:{"click":function($event){return _vm.downloadFile(_vm.sceneId)}}},[_c('v-icon',[_vm._v("mdi-download")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }